import { setOrganisationIdSource, setUnauthenticatedHandler } from '../api';
import { createSessionStore, type SessionStore } from './store';

/**
 * The one session the application has (P0-WEB-07).
 *
 * A module singleton for the same reason `portal-client.ts` is one: loaders
 * read it, and a loader runs outside the component tree.
 */
export const sessionStore: SessionStore = createSessionStore();

/**
 * Connects the session to the transport.
 *
 * Called once from `main.tsx`, explicitly, rather than as an import-time side
 * effect — `packages/i18n` makes the argument in `i18n.ts` and it holds here:
 * import-time wiring runs before an app has decided anything, and it is
 * invisible at the point it matters.
 *
 * Two ports, both installed in P0-WEB-04 and left unbound until now:
 *
 *  - `X-Organisation-Id` on every request, from one source, so no call site can
 *    forget it (P0-PLAT-10).
 *  - The reaction to a 401. It clears the session and nothing else — the
 *    redirect is the loader's, because only the loader knows where the user
 *    was, and a transport that navigates would fight the router for control of
 *    the history stack.
 */
export function installSessionPorts(): void {
  setOrganisationIdSource(() => sessionStore.getSnapshot().organisationId);

  setUnauthenticatedHandler(() => {
    sessionStore.clear();
  });
}
